import React from "react";
import RewardForm from "../components/RewardForm";

const CreateRewardPage = () => {
  return <RewardForm />;
};

export default CreateRewardPage;
